/**
 * Grain — a brief monochrome dissolve on page load and on internal navigation.
 * Ported from v1. Immersive only; standard and reduced-motion never see it.
 */

/* Inlined rather than imported — see the note at the top of mode.js. */
const getMode = () =>
  document.documentElement.classList.contains('mode-immersive') ? 'immersive' : 'standard';

const grain = document.querySelector('.grain');

if (grain) {
  const active = () =>
    getMode() === 'immersive' &&
    !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const flash = () => {
    if (!active()) return;
    grain.classList.remove('is-leaving');
    grain.classList.add('is-entering');
    window.setTimeout(() => grain.classList.remove('is-entering'), 340);
  };

  flash();

  document.addEventListener('click', (event) => {
    if (!active()) return;
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const link = event.target.closest('a[href]');
    if (!link || link.hasAttribute('download')) return;
    if (link.target && link.target !== '_self') return;
    if (link.hasAttribute('data-no-transition')) return;

    const href = link.getAttribute('href');
    if (!href || /^(#|mailto:|tel:|javascript:)/.test(href)) return;

    let url;
    try {
      url = new URL(href, window.location.href);
    } catch (e) {
      return;
    }
    if (url.origin !== window.location.origin) return;
    if (url.pathname === window.location.pathname && url.search === window.location.search) return;

    grain.classList.remove('is-entering');
    grain.classList.add('is-leaving');
  });

  // Back/forward cache restores should feel the same as a fresh load.
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      grain.classList.remove('is-leaving');
      flash();
    }
  });
}
